import { memo } from 'react';
import { Rect } from 'reactflow';

import { MarqueeBoxStyled } from './MarqueeBox.styled';

type Props = {
  rect: Rect | null;
};

export const MarqueeBox = memo(function MarqueeBox({ rect }: Props) {
  if (!rect) return null;

  return (
    <MarqueeBoxStyled
      style={{
        transform: `translate(${rect.x}px, ${rect.y}px)`,
        width: rect.width,
        height: rect.height,
      }}
    />
  );
});
